// extracted by mini-css-extract-plugin
export default {"img_contianer":"ChatImage_img_contianer__yd3IY","fullscreen_button":"ChatImage_fullscreen_button__06ENl"};